export interface AgencyRatings {
    snP?: string,
    moodys?: string,
    fitch?: string
}

export enum FitchRating {
    AAA = 'AAA',
    AAPlus = 'AA+',
    AA = 'AA',
    AAMinus = 'AA-',
    APlus = 'A+',
    A = 'A',
    AMinus = 'A-',
    BBBPlus = 'BBB+',
    BBB = 'BBB',
    BBBMinus = 'BBB-',
    BBPlus = 'BB+',
    BB = 'BB',
    BBMinus = 'BB-',
    BPlus = 'B+',
    B = 'B',
    BMinus = 'B-',
    CCCPlus = 'CCC+',
    CCC = 'CCC',
    CCCMinus = 'CCC-',
    CC = 'CC',
    C = 'C',
    DDD = 'DDD',
    DD = 'DD',
    D = 'DD',
    NR = 'NR'
}

export enum MoodysRating {
    Aaa = 'Aaa',
    Aa1 = 'Aa1',
    Aa2 = 'Aa2',
    Aa3 = 'Aa3',
    A1 = 'A1',
    A2 = 'A2',
    A3 = 'A3',
    Baa1 = 'Baa1',
    Baa2 = 'Baa2',
    Baa3 = 'Baa3',
    Ba1 = 'Ba1',
    Ba2 = 'Ba2',
    Ba3 = 'Ba3',
    B1 = 'B1',
    B2 = 'B2',
    B3 = 'B3',
    Caa1 = 'Caa1',
    Caa2 = 'Caa2',
    Caa3 = 'Caa3',
    Ca = 'Ca',
    C = 'C',
    NR = 'NR'
}

export enum SnpRating {
    AAA = 'AAA',
    AAPlus = 'AA+',
    AA = 'AA',
    AAMinus = 'AA-',
    APlus = 'A+',
    A = 'A',
    AMinus = 'A-',
    BBBPlus = 'BBB+',
    BBB = 'BBB',
    BBBMinus = 'BBB-',
    BBPlus = 'BB+',
    BB = 'BB',
    BBMinus = 'BB-',
    BPlus = 'B+',
    B = 'B',
    BMinus = 'B-',
    CCCPlus = 'CCC+',
    CCC = 'CCC',
    CCCMinus = 'CCC-',
    CCPlus = 'CC+',
    CC = 'CC',
    CCMinus = 'CC-',
    C = 'C',
    D = 'D',
    NR = 'NR'
}


export function parseRating<T extends Record<string, string>>(
    enumObject: T,
    val: string,
    emptyValue: T[keyof T]): T[keyof T] {
    if (!val) return emptyValue;

    const enumName = (Object.keys(enumObject) as Array<keyof T>).find(
        k => val.localeCompare(enumObject[k], undefined, { sensitivity: 'accent' }) === 0
    );

    return enumName ? enumObject[enumName] : emptyValue;
}
